import PropTypes from 'prop-types';
import { Dialog as DialogV4, DialogContent } from '@mui/material';

const Dialog = ({
  open,
  onClose = undefined,
  children,
  contentClassName = null,
  bodyClassName = null,
}) => (
  <DialogV4
    open={open}
    onClose={onClose}
    slotProps={
      contentClassName
        ? {
            paper: {
              className: contentClassName,
              sx: { overflow: 'visible' },
            },
          }
        : { paper: { sx: { overflow: 'visible' } } }
    }
  >
    {/*
      MUI v5+ DialogContent defaults to overflow-y:auto, which clips the
      absolutely positioned Close (X) icons used across schedule/session-notes
      modals. Keep overflow visible and establish a positioning context.
    */}
    <DialogContent
      sx={{ padding: '30px', overflow: 'visible', position: 'relative' }}
      className={bodyClassName || undefined}
    >
      {children}
    </DialogContent>
  </DialogV4>
);

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
};

export default Dialog;
